export const SET_SELECTIONS = (state, action) => {
  const { gridId, selections } = action.payload;
  const newstate = {
    ...state,
    [gridId]: {
      ...state[gridId],
      selections
    }
  };
  return newstate;
};

export const SET_SEARCH = (state, action) => {
  const { gridId, search } = action.payload;
  const newstate = {
    ...state,
    [gridId]: {
      ...state[gridId],
      search
    }
  };
  return newstate;
};
